module.exports = __webpack_public_path__ + "img/chevron-down.a1f4bec6.svg";